import SettingsGeneralPage from './general';
import SettingsPermissionsPage from './permissions';
import DevToolsPage from '../development';
import SettingsProductsImport from './products-import';
import SettingsContentBuilderLibraryGenerate from './content-builder-library-generate'; // eslint-disable-line max-len
import SettingsProductGallerySort from './product-gallery-sort'; // eslint-disable-line max-len
import SettingsProductGalleryGenerate from './product-gallery-generate'; // eslint-disable-line max-len
import SettingsMagicText from './magic-text'; // eslint-disable-line max-len

import tests from '../../helpers/tests';

const {
  viewerIsNotAdmin,
  viewerIsAdminAndDoesNotHavePermission,
} = tests;

export default [
  'Group',
  {
    title: 'Settings',
    icon: 'tool',
    hidden: [viewerIsNotAdmin],
    skip: [
      viewerIsNotAdmin,
      viewerIsAdminAndDoesNotHavePermission('settings'),
    ],
    pages: [
      SettingsGeneralPage,
      SettingsPermissionsPage,
      DevToolsPage,
    ],
  },
];

export const aiPages = [
  'Group',
  {
    title: 'AI',
    icon: 'robot',
    hidden: [viewerIsNotAdmin],
    skip: [
      viewerIsNotAdmin,
      viewerIsAdminAndDoesNotHavePermission('ai'),
    ],
    pages: [
      SettingsProductsImport,
      SettingsProductGallerySort,
      SettingsProductGalleryGenerate,
      SettingsContentBuilderLibraryGenerate,
      SettingsMagicText,
    ],
  },
];
